import { apiV2 } from './api';

export interface CalendarCategory {
  id: number;
  name: string;
  color: string;
  aktiv: boolean;
}

export interface CalendarEvent {
  id: number;
  title: string;
  description: string | null;
  start_at: string;
  end_at: string | null;
  all_day: boolean;
  category: CalendarCategory | null;
  /** Besitzer — in wessen Kalender der Termin liegt (null = ohne Zuordnung). */
  admin_id: number | null;
  admin_name: string | null;
  /** Exchange-Sync: liegt der Termin auch im Outlook-Kalender des Besitzers? */
  ms_synced?: boolean;
  /** Letzter Fehler beim Spiegeln nach Outlook (null = alles gut). */
  ms_sync_error?: string | null;
  /**
   * Paket F1 — PB-Bezug (Wiedervorlage-/Anamnese-Termine tragen die PB, für
   * die sie angelegt wurden). null = freier Termin ohne PB-Bezug.
   */
  user_id?: number | null;
  user_name?: string | null;
  /** 1 = BK, 2 = PB — bestimmt, wohin „Profil öffnen" verlinkt. */
  user_role?: number | null;
  /** Zusammen mit `profile_id` der Ziel-Pfad fürs Deep-Link „Profil öffnen". */
  account_id?: number | null;
  profile_id?: number | null;
}

export interface CalendarEventInput {
  title: string;
  description?: string | null;
  start_at: string;
  end_at?: string | null;
  all_day?: boolean;
  category_id?: number | null;
}

export const v2CalendarCategories = {
  list: async (): Promise<CalendarCategory[]> => {
    const res = await apiV2.get<{ data: CalendarCategory[] }>('/admin/calendar-categories');
    return res.data.data ?? [];
  },
  create: async (input: { name: string; color: string }): Promise<CalendarCategory> => {
    const res = await apiV2.post<{ data: CalendarCategory }>('/admin/calendar-categories', input);
    return res.data.data;
  },
  update: async (id: number, input: { name?: string; color?: string; aktiv?: boolean }): Promise<CalendarCategory> => {
    const res = await apiV2.put<{ data: CalendarCategory }>(`/admin/calendar-categories/${id}`, input);
    return res.data.data;
  },
  remove: async (id: number): Promise<void> => {
    await apiV2.delete(`/admin/calendar-categories/${id}`);
  },
};

export const v2CalendarEvents = {
  /**
   * @param mine nur Termine im eigenen Kalender (sonst alle, wie bisher).
   *             Seit Stage-Aktionen Termine für die zuständige Person anlegen,
   *             ist der geteilte Kalender ohne Filter schnell unübersichtlich.
   */
  list: async (start: string, end: string, mine = false): Promise<CalendarEvent[]> => {
    const params: Record<string, string> = { start, end };
    if (mine) params.mine = '1';
    const res = await apiV2.get<{ data: CalendarEvent[] }>('/admin/calendar-events', { params });
    return res.data.data ?? [];
  },
  create: async (input: CalendarEventInput): Promise<CalendarEvent> => {
    const res = await apiV2.post<{ data: CalendarEvent }>('/admin/calendar-events', input);
    return res.data.data;
  },
  update: async (id: number, input: Partial<CalendarEventInput>): Promise<CalendarEvent> => {
    const res = await apiV2.put<{ data: CalendarEvent }>(`/admin/calendar-events/${id}`, input);
    return res.data.data;
  },
  remove: async (id: number): Promise<void> => {
    await apiV2.delete(`/admin/calendar-events/${id}`);
  },
};
